var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinoculars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 48C416 39.125 408.875 32 400 32H336C327.125 32 320 39.125 320 48V96H416V48ZM63.875 160.1C61.336 253.891 3.5 274.295 0 404V448C0 465.6 14.398 480 32 480H160C177.602 480 192 465.6 192 448V128H95.875C78.258 128 64.352 142.486 63.875 160.1ZM448.125 160.1C447.648 142.486 433.742 128 416.125 128H320V448C320 465.6 334.398 480 352 480H480C497.602 480 512 465.6 512 448V404C508.5 274.295 450.664 253.891 448.125 160.1ZM224 288H288V128H224V288ZM176 32H112C103.125 32 96 39.125 96 48V96H192V48C192 39.125 184.875 32 176 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinoculars);
export default __webpack_public_path__ + "static/media/binoculars.d990feb5e175fb36aabd30b554801ebf.svg";
export { ForwardRef as ReactComponent };